/**
 * List Item
 * Individual app style list card
 */
import type { IconName } from '@fortawesome/fontawesome-svg-core';
import { useTheme } from '@mui/material/styles';
import React from 'react';

import Icon from '@components/Icon/Icon';

import {
  CardDiv,
  Description,
  InfoSection,
  SubTitle,
  Title,
} from './ListItem.style';

const ListItem: React.FC<{
  description?: React.ReactNode;
  title?: string;
  subtitle?: string;
  onClick?: () => void;
  titleColor?: string;
  subtitleColor?: string;
  children?: React.ReactNode;
  icon?: IconName;
  isSelected?: boolean;
}> = ({
  description = '',
  title = '',
  subtitle = '',
  onClick,
  titleColor,
  subtitleColor,
  children = null,
  icon = 'chevron-down',
  isSelected = false,
}) => {
  const { palette } = useTheme();

  const resolvedTitleColor = titleColor ?? palette.text.primary;
  const resolvedSubtitleColor = subtitleColor ?? palette.text.primary;

  return (
    <CardDiv
      clickable={Boolean(onClick)}
      isSelected={isSelected}
      onClick={onClick}
    >
      {Boolean(title || subtitle || description) && (
        <InfoSection>
          <Title titleColor={resolvedTitleColor}>{title}</Title>
          <SubTitle subtitleColor={resolvedSubtitleColor}>{subtitle}</SubTitle>
          <Description>{description}</Description>
        </InfoSection>
      )}
      {children}
      {onClick ? (
        <Icon
          clickable
          color="text.primary"
          name={icon}
          rotation={icon === 'chevron-down' ? -90 : 0}
          type="fas"
        />
      ) : null}
    </CardDiv>
  );
};

export default ListItem;
